import Breadcrumb from '../components/Breadcrumb'
import { Helmet } from 'react-helmet'
import Mail from '../components/Mail'
import { initialize } from '../store/pagedata'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

const ContactUs = () => {
  const dispatch = useDispatch()
  const destination = 'edhrec@edhrec.com'

  useEffect(() => {
    dispatch(initialize())
  }, [])

  return (
    <>
      <Helmet>
        <meta name='description' content='Contact the EDHREC team' />
        <meta name='keywords' content='EDHREC,contact,email,message' />
        <title>Contact Us | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/contact-us': 'Contact Us' }]} />
      <h1 className='page-heading'>Contact Us</h1>
      <Mail
        description={
          <p>
            {'Use the form below, or email us at '}
            <a href={`mailto:${destination}`} rel='noreferrer' target='_blank'>
              {destination}
            </a>
            .
          </p>
        }
        destination={destination}
      />
    </>
  )
}

export default ContactUs
